import 'css-chunksrc/client/scenes/projectCreationForm/projectPortfoliosList/portfolioAssignation/styles.scss';export default {
  "portfolioAssignation": "_portfolioAssignation_1khhw_1",
  "search": "_search_1khhw_7",
  "input": "_input_1khhw_11",
  "list": "_list_1khhw_24",
  "item": "_item_1khhw_30",
  "footer": "_footer_1khhw_35",
  "addPortfolio": "_addPortfolio_1khhw_39"
};